import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { useSubscription } from '@/hooks/useSubscription';
import { TIERS } from '@/data/tiers';
import TierCard from '@/components/pricing/TierCard';
import { signOut } from '@/lib/auth';

export default function Welcome() {
  const { user } = useAuth();
  const { isActive, loading } = useSubscription();
  const navigate = useNavigate();
  const greeting = firstName(user?.displayName, user?.email);

  if (!loading && isActive) {
    return <Navigate to="/inventory" replace />;
  }

  async function handleSignOut() {
    await signOut();
    navigate('/', { replace: true });
  }

  return (
    <div className="app">
      <div className="main">
        <div className="eyebrow">Account Created · No Subscription Yet</div>
        <h1 className="h-display">
          {greeting ? <>Welcome, <em style={{ fontFamily: 'var(--serif)', color: 'var(--gold)', fontStyle: 'italic' }}>{greeting}</em>.</> : 'Welcome.'}
        </h1>
        <p className="lead" style={{ marginBottom: 36 }}>
          Your account is live. Pick a tier to unlock the catalog — inventory, VIN scanner, quote
          builder, branded PDF exports. Cancel anytime, every plan ships with the SWC Promise.
        </p>

        <div className="tiers" style={{ marginBottom: 36 }}>
          {TIERS.map((t) => (
            <TierCard key={t.id} tier={t} />
          ))}
        </div>

        <div className="card-elev" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div>
            <div className="eyebrow" style={{ marginBottom: 4 }}>Not ready yet?</div>
            <p style={{ fontSize: 13.5, color: 'var(--text-dim)' }}>
              Browse the marketing site without a subscription. The subscription gate only covers
              the catalog and tools.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <Link to="/account" className="btn ghost sm">Account</Link>
            <button type="button" className="btn dark sm" onClick={handleSignOut}>Sign out</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function firstName(displayName: string | null | undefined, email: string | null | undefined): string {
  if (displayName && displayName.trim()) {
    const first = displayName.trim().split(/\s+/)[0];
    if (first) return first;
  }
  if (email) {
    const local = email.split('@')[0];
    if (local) return local;
  }
  return '';
}
